// extracted by mini-css-extract-plugin
module.exports = {"Button":"MultiFileUploadButton_Button__1eVI8"};